/* eslint-disable react/react-in-jsx-scope */
import { DropdownMenuCheckboxItem } from "@/components/ui/dropdown-menu";
import { useState } from "react";

const FilterItem = ({
  option,
  selectedValues,
  handleCheckboxChange,
  handleGroupCheckboxChange,
}) => {
  const [isChildrenVisible, setIsChildrenVisible] = useState(false);

  // Vérifie si tous les enfants sont sélectionnés
  const hasChildren = option?.children?.length > 0;
  const childrenValues = option.children?.map((c) => c.value) || [];

  const areAllChildrenSelected =
    hasChildren && childrenValues.every((val) => selectedValues.includes(val));

  const isPartiallySelected =
    hasChildren &&
    childrenValues.some((val) => selectedValues.includes(val)) &&
    !areAllChildrenSelected;

  return (
    <div className="flex items-start">
      {hasChildren && (
        <button
          className="size-4 flex justify-center items-center bg-gray-50 rounded-sm mt-2"
          onClick={() => setIsChildrenVisible(!isChildrenVisible)}
        >
          {!isChildrenVisible ? (
            <span className="w-0 h-0 border-t-4 border-b-4 border-l-4 border-t-transparent border-b-transparent border-l-black inline-block"></span>
          ) : (
            <span className="w-0 h-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-black inline-block"></span>
          )}
        </button>
      )}

      <div className="flex flex-col">
        <DropdownMenuCheckboxItem
          checked={selectedValues.includes(option.value)}
          onSelect={(e) => e.preventDefault()}
          onCheckedChange={(checked) =>
            handleGroupCheckboxChange(option.value, checked, childrenValues)
          }
          className="flex items-center gap-2 w-full"
          classNameCheck={isPartiallySelected ? "opacity-30" : ""}
        >
          {option.label}
        </DropdownMenuCheckboxItem>

        {hasChildren && isChildrenVisible && (
          <div className="flex flex-col ml-4">
            {option.children.map((item, key) => (
              <DropdownMenuCheckboxItem
                key={key}
                checked={selectedValues.includes(item.value)}
                onSelect={(e) => e.preventDefault()}
                onCheckedChange={(checked) =>
                  handleCheckboxChange(item.value, checked)
                }
                className="flex items-center gap-2 w-full"
              >
                {item.label}
              </DropdownMenuCheckboxItem>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default FilterItem;
